module.exports = __webpack_public_path__ + "assets/interview.509acd9b.svg";